module.exports = __webpack_public_path__ + "static/media/17UN-Women4.c3b08398.jpg";